/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import { StatoCategoriaPDE } from '../../Shared/Profilo/usePianoEccellenza';
import RiempimentoEsclusivaEccellenza from '../shared/RiempimentoEsclusivaEccellenza';

function ImmagineRiempiemnto() {
  return (
    <img
      className="helpdesk-frontend-step__image helpdesk-frontend-scelta-servizio__image"
      src="/images/Illustrazione-Rifiuta.svg"
      alt="immagine-scelta-servizio"
    />
  );
}

/**
*/
export default function Riempimento({ statoUfficio, statoCategoria }) {
  if (statoCategoria === StatoCategoriaPDE.ESCLUSIVA_ECCELLENZA) {
    return <RiempimentoEsclusivaEccellenza statoUfficio={statoUfficio} />;
  }

  return <ImmagineRiempiemnto />;
}

Riempimento.propTypes = {
  statoUfficio: PropTypes.string.isRequired,
  statoCategoria: PropTypes.string,
};

Riempimento.defaultProps = {
  statoCategoria: undefined,
};
